import { render, staticRenderFns } from "./abstract_consultation_edit.vue?vue&type=template&id=5b193d3e&scoped=true"
import script from "./abstract_consultation_edit.vue?vue&type=script&lang=js"
export * from "./abstract_consultation_edit.vue?vue&type=script&lang=js"
import style0 from "./abstract_consultation_edit.vue?vue&type=style&index=0&id=5b193d3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b193d3e",
  null
  
)

export default component.exports